import RpcClass from "../../../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

import BaseFormConfig from "../../../../../../../server/com/silkplm/engine/forms/schema/BaseFormConfig.js";
let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.engine.forms.schema.definition.FormConfig';

import LocalDate from "../../../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../../../server/LocalTime.js";



class FormConfig extends BaseFormConfig {

    /**
     *  @class FormConfig
     *  @alias module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig
     *  
     *  @property {boolean} listPermitted
     *  @property {boolean} readPermitted
     *  @property {boolean} writePermitted

     * */
    constructor(){
        super();

        /** @type {boolean}  */
        this.addFromForeignSelect = null;
        /** @type {boolean}  */
        this.allowFormColumns = null;
        /** @type {string}  */
        this.alternativeMenuLabelInConfiguration = null;
        /** @type {boolean}  */
        this.appTranslations = null;
        /** @type {string}  */
        this.auditPermissionLabel = null;
        /** @type {string}  */
        this.basicInfoLabel = null;
        /** @type {boolean}  */
        this.beforeDeleteDialogInfo = null;
        /** @type {boolean}  */
        this.canChain = null;
        /** @type {boolean}  */
        this.canClone = null;
        /** @type {string}  */
        this.cellValueFieldForDynamicColumns = null;
        /** @type {string}  */
        this.classAlias = null;
        /** @type {*}  */
        this.classForDynamicColumnsLabel = null;
        /** @type {*}  */
        this.classForValueOfDynamicCell = null;
        /** @type {boolean}  */
        this.classIsDynamic = null;
        /** @type {boolean}  */
        this.closeFormAfterInsertEntity = null;
        /** @type {string}  */
        this.clusterByField = null;
        /** @type {string}  */
        this.clusterByFieldLabel = null;
        /** @type {string}  */
        this.clusterType = null;
        /** @type {string}  */
        this.columnFieldForDynamicColumns = null;
        /** @type {module:src/server/com/silkplm/engine/forms/schema/definition/AdvancedPermissionConfig.AdvancedPermissionConfig[]}  */
        this.dataPermissions = null;
        /** @type {boolean}  */
        this.defaultVisible = null;
        /** @type {string}  */
        this.descriptionToFormUnderGrid = null;
        /** @type {*}  */
        this.detailToClasses = null;
        /** @type {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig[]}  */
        this.details = null;
        /** @type {string[]}  */
        this.detailsFilteringFields = null;
        /** @type {boolean}  */
        this.devOnly = null;
        /** @type {*}  */
        this.dynamicCells = null;
        /** @type {*}  */
        this.dynamicColumns = null;
        /** @type {*}  */
        this.dynamicRows = null;
        /** @type {boolean}  */
        this.editFromForeignSelect = null;
        /** @type {boolean}  */
        this.editableForm = null;
        /** @type {boolean}  */
        this.editableGrid = null;
        /** @type {string}  */
        this.effectivePermissionAudit = null;
        /** @type {string}  */
        this.effectivePermissionList = null;
        /** @type {string}  */
        this.effectivePermissionRead = null;
        /** @type {string}  */
        this.effectivePermissionWrite = null;
        /** @type {boolean}  */
        this.enableShowDetailsByDoubleClick = null;
        /** @type {module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]}  */
        this.enabledByFeatureFlags = null;
        /** @type {boolean}  */
        this.enabledConfiguration = null;
        /** @type {boolean}  */
        this.enabledFilters = null;
        /** @type {module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]}  */
        this.enabledPrintoutsByFeatureFlags = null;
        /** @type {string}  */
        this.entityLabelExpression = null;
        /** @type {string}  */
        this.entityLabelFunction = null;
        /** @type {string}  */
        this.entityName = null;
        /** @type {string}  */
        this.entityPlural = null;
        /** @type {string}  */
        this.extendedClass = null;
        /** @type {Object.<string, module:src/server/com/silkplm/engine/forms/schema/definition/ExtendedConfig.ExtendedConfig>}  */
        this.extendedConfigs = null;
        /** @type {module:src/server/com/silkplm/engine/forms/schema/definition/FormExtensionConfig.FormExtensionConfig[]}  */
        this.extensions = null;
        /** @type {string}  */
        this.extraFieldOrderForDynamicColumns = null;
        /** @type {string}  */
        this.fieldByWhichColoringWillBeDistinguishedForDynamicColumns = null;
        /** @type {Object.<string, module:src/server/com/silkplm/engine/forms/schema/definition/FieldCloneOptionsConfig.FieldCloneOptionsConfig>}  */
        this.fieldCloneOptions = null;
        /** @type {Object.<string, string[]>}  */
        this.fieldDependencies = null;
        /** @type {string}  */
        this.fieldForFilterForDynamicColumns = null;
        /** @type {string}  */
        this.fieldOrderForDynamicColumns = null;
        /** @type {module:src/server/com/silkplm/engine/forms/schema/definition/FormFieldConfig.FormFieldConfig[]}  */
        this.fields = null;
        /** @type {Object.<string, module:src/server/com/silkplm/engine/forms/schema/definition/FormFieldConfig.FormFieldConfig>}  */
        this.fieldsMap = null;
        /** @type {string}  */
        this.footerColCssClass = null;
        /** @type {string}  */
        this.footerHtml = null;
        /** @type {boolean}  */
        this.forceLabelTranslation = null;
        /** @type {string}  */
        this.formClass = null;
        /** @type {string}  */
        this.formClassLong = null;
        /** @type {string}  */
        this.formColorHex = null;
        /** @type {string}  */
        this.formDockFlexCss = null;
        /** @type {number}  */
        this.formId = null;
        /** @type {boolean}  */
        this.formIsView = null;
        /** @type {string}  */
        this.formNameLabelInConfiguration = null;
        /** @type {string}  */
        this.formTitle = null;
        /** @type {boolean}  */
        this.hasConditionalAdd = null;
        /** @type {boolean}  */
        this.hasCustomCanDelete = null;
        /** @type {boolean}  */
        this.hasIntegrationRequiredFieldsButton = null;
        /** @type {boolean}  */
        this.hasSummaryFunction = null;
        /** @type {boolean}  */
        this.hasTabs = null;
        /** @type {string}  */
        this.headerColCssClass = null;
        /** @type {string}  */
        this.headerHtml = null;
        /** @type {string}  */
        this.icon = null;
        /** @type {string[]}  */
        this.ignoredUniqueFieldsInClone = null;
        /** @type {boolean}  */
        this.interfaceTranslation = null;
        /** @type {boolean}  */
        this.isDetail = null;
        /** @type {boolean}  */
        this.isDynamic = null;
        /** @type {boolean}  */
        this.isExtension = null;
        /** @type {string}  */
        this.listPermissionLabel = null;
        /** @type {module:src/server/com/silkplm/engine/forms/schema/MasterFormConfig.MasterFormConfig}  */
        this.masterFormConfig = null;
        /** @type {string}  */
        this.menuGroup = null;
        /** @type {string}  */
        this.menuGroupLabelInConfiguration = null;
        /** @type {string}  */
        this.menuLabel = null;
        /** @type {number}  */
        this.menuOrder = null;
        /** @type {module:src/server/com/silkplm/engine/forms/schema/definition/MixinFormComponentConfig.MixinFormComponentConfig[]}  */
        this.mixins = null;
        /** @type {string}  */
        this.moduleLabelInConfiguration = null;
        /** @type {string[]}  */
        this.modules = null;
        /** @type {string}  */
        this.multiAddForeignKey = null;
        /** @type {boolean}  */
        this.multiGroupDeleteAllow = null;
        /** @type {boolean}  */
        this.onlyEmbedded = null;
        /** @type {Object.<string, string>}  */
        this.printouts = null;
        /** @type {string}  */
        this.readPermissionLabel = null;
        /** @type {boolean}  */
        this.reloadColumnsWhenDynamicsAreTab = null;
        /** @type {boolean}  */
        this.reloadTab = null;
        /** @type {boolean}  */
        this.restrictedAudit = null;
        /** @type {boolean}  */
        this.restrictedList = null;
        /** @type {boolean}  */
        this.restrictedRead = null;
        /** @type {boolean}  */
        this.restrictedWrite = null;
        /** @type {*}  */
        this.resultComparator = null;
        /** @type {string}  */
        this.rootClassShortId = null;
        /** @type {string}  */
        this.rowFieldForDynamicColumns = null;
        /** @type {module:src/server/com/silkplm/engine/forms/schema/definition/fields/SecuredFieldConfig.SecuredFieldConfig[]}  */
        this.securedFields = null;
        /** @type {module:src/server/com/silkplm/engine/forms/schema/definition/FormShadowFieldConfig.FormShadowFieldConfig[]}  */
        this.shadowFields = null;
        /** @type {boolean}  */
        this.showAdd = null;
        /** @type {boolean}  */
        this.showColumns = null;
        /** @type {boolean}  */
        this.showDelete = null;
        /** @type {boolean}  */
        this.showExport = null;
        /** @type {boolean}  */
        this.showImport = null;
        /** @type {boolean}  */
        this.showInMenu = null;
        /** @type {boolean}  */
        this.showProductInfoBranding = null;
        /** @type {boolean}  */
        this.streamingMode = null;
        /** @type {string}  */
        this.targetFieldFromClassForDynamicCell = null;
        /** @type {*}  */
        this.textBelowTheListClazz = null;
        /** @type {string}  */
        this.textBelowTheListExpression = null;
        /** @type {string}  */
        this.textBelowTheListFunction = null;
        /** @type {string[]}  */
        this.translatedFields = null;
        /** @type {string}  */
        this.viewName = null;
        /** @type {module:src/server/com/silkplm/engine/forms/schema/definition/ClassWatch.ClassWatch[]}  */
        this.watchedClasses = null;
        /** @type {string}  */
        this.writePermissionLabel = null;

    }





    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withAddFromForeignSelect(val){
        this.addFromForeignSelect = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withAllowFormColumns(val){
        this.allowFormColumns = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withAlternativeMenuLabelInConfiguration(val){
        this.alternativeMenuLabelInConfiguration = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withAppTranslations(val){
        this.appTranslations = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withAuditPermissionLabel(val){
        this.auditPermissionLabel = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withBasicInfoLabel(val){
        this.basicInfoLabel = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withBeforeDeleteDialogInfo(val){
        this.beforeDeleteDialogInfo = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withCanChain(val){
        this.canChain = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withCanClone(val){
        this.canClone = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withCellValueFieldForDynamicColumns(val){
        this.cellValueFieldForDynamicColumns = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withClassAlias(val){
        this.classAlias = val;
        return this;
    };


    /**
     * @param val {*}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withClassForDynamicColumnsLabel(val){
        this.classForDynamicColumnsLabel = val;
        return this;
    };


    /**
     * @param val {*}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withClassForValueOfDynamicCell(val){
        this.classForValueOfDynamicCell = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withClassIsDynamic(val){
        this.classIsDynamic = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withCloseFormAfterInsertEntity(val){
        this.closeFormAfterInsertEntity = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withClusterByField(val){
        this.clusterByField = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withClusterByFieldLabel(val){
        this.clusterByFieldLabel = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withClusterType(val){
        this.clusterType = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withColumnFieldForDynamicColumns(val){
        this.columnFieldForDynamicColumns = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/forms/schema/definition/AdvancedPermissionConfig.AdvancedPermissionConfig[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withDataPermissions(val){
        this.dataPermissions = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withDefaultVisible(val){
        this.defaultVisible = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withDescriptionToFormUnderGrid(val){
        this.descriptionToFormUnderGrid = val;
        return this;
    };


    /**
     * @param val {*}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withDetailToClasses(val){
        this.detailToClasses = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withDetails(val){
        this.details = val;
        return this;
    };


    /**
     * @param val {string[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withDetailsFilteringFields(val){
        this.detailsFilteringFields = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withDevOnly(val){
        this.devOnly = val;
        return this;
    };


    /**
     * @param val {*}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withDynamicCells(val){
        this.dynamicCells = val;
        return this;
    };


    /**
     * @param val {*}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withDynamicColumns(val){
        this.dynamicColumns = val;
        return this;
    };


    /**
     * @param val {*}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withDynamicRows(val){
        this.dynamicRows = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withEditFromForeignSelect(val){
        this.editFromForeignSelect = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withEditableForm(val){
        this.editableForm = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withEditableGrid(val){
        this.editableGrid = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withEffectivePermissionAudit(val){
        this.effectivePermissionAudit = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withEffectivePermissionList(val){
        this.effectivePermissionList = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withEffectivePermissionRead(val){
        this.effectivePermissionRead = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withEffectivePermissionWrite(val){
        this.effectivePermissionWrite = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withEnableShowDetailsByDoubleClick(val){
        this.enableShowDetailsByDoubleClick = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withEnabledByFeatureFlags(val){
        this.enabledByFeatureFlags = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withEnabledConfiguration(val){
        this.enabledConfiguration = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withEnabledFilters(val){
        this.enabledFilters = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withEnabledPrintoutsByFeatureFlags(val){
        this.enabledPrintoutsByFeatureFlags = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withEntityLabelExpression(val){
        this.entityLabelExpression = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withEntityLabelFunction(val){
        this.entityLabelFunction = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withEntityName(val){
        this.entityName = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withEntityPlural(val){
        this.entityPlural = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withExtendedClass(val){
        this.extendedClass = val;
        return this;
    };


    /**
     * @param val {Object.<string, module:src/server/com/silkplm/engine/forms/schema/definition/ExtendedConfig.ExtendedConfig>}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withExtendedConfigs(val){
        this.extendedConfigs = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/forms/schema/definition/FormExtensionConfig.FormExtensionConfig[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withExtensions(val){
        this.extensions = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withExtraFieldOrderForDynamicColumns(val){
        this.extraFieldOrderForDynamicColumns = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withFieldByWhichColoringWillBeDistinguishedForDynamicColumns(val){
        this.fieldByWhichColoringWillBeDistinguishedForDynamicColumns = val;
        return this;
    };


    /**
     * @param val {Object.<string, module:src/server/com/silkplm/engine/forms/schema/definition/FieldCloneOptionsConfig.FieldCloneOptionsConfig>}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withFieldCloneOptions(val){
        this.fieldCloneOptions = val;
        return this;
    };


    /**
     * @param val {Object.<string, string[]>}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withFieldDependencies(val){
        this.fieldDependencies = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withFieldForFilterForDynamicColumns(val){
        this.fieldForFilterForDynamicColumns = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withFieldOrderForDynamicColumns(val){
        this.fieldOrderForDynamicColumns = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/forms/schema/definition/FormFieldConfig.FormFieldConfig[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withFields(val){
        this.fields = val;
        return this;
    };


    /**
     * @param val {Object.<string, module:src/server/com/silkplm/engine/forms/schema/definition/FormFieldConfig.FormFieldConfig>}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withFieldsMap(val){
        this.fieldsMap = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withFooterColCssClass(val){
        this.footerColCssClass = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withFooterHtml(val){
        this.footerHtml = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withForceLabelTranslation(val){
        this.forceLabelTranslation = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withFormClass(val){
        this.formClass = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withFormClassLong(val){
        this.formClassLong = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withFormColorHex(val){
        this.formColorHex = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withFormDockFlexCss(val){
        this.formDockFlexCss = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withFormId(val){
        this.formId = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withFormIsView(val){
        this.formIsView = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withFormNameLabelInConfiguration(val){
        this.formNameLabelInConfiguration = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withFormTitle(val){
        this.formTitle = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withHasConditionalAdd(val){
        this.hasConditionalAdd = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withHasCustomCanDelete(val){
        this.hasCustomCanDelete = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withHasIntegrationRequiredFieldsButton(val){
        this.hasIntegrationRequiredFieldsButton = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withHasSummaryFunction(val){
        this.hasSummaryFunction = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withHasTabs(val){
        this.hasTabs = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withHeaderColCssClass(val){
        this.headerColCssClass = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withHeaderHtml(val){
        this.headerHtml = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withIcon(val){
        this.icon = val;
        return this;
    };


    /**
     * @param val {string[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withIgnoredUniqueFieldsInClone(val){
        this.ignoredUniqueFieldsInClone = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withInterfaceTranslation(val){
        this.interfaceTranslation = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withIsDetail(val){
        this.isDetail = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withIsDynamic(val){
        this.isDynamic = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withIsExtension(val){
        this.isExtension = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withListPermissionLabel(val){
        this.listPermissionLabel = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/forms/schema/MasterFormConfig.MasterFormConfig}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withMasterFormConfig(val){
        this.masterFormConfig = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withMenuGroup(val){
        this.menuGroup = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withMenuGroupLabelInConfiguration(val){
        this.menuGroupLabelInConfiguration = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withMenuLabel(val){
        this.menuLabel = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withMenuOrder(val){
        this.menuOrder = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/forms/schema/definition/MixinFormComponentConfig.MixinFormComponentConfig[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withMixins(val){
        this.mixins = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withModuleLabelInConfiguration(val){
        this.moduleLabelInConfiguration = val;
        return this;
    };


    /**
     * @param val {string[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withModules(val){
        this.modules = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withMultiAddForeignKey(val){
        this.multiAddForeignKey = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withMultiGroupDeleteAllow(val){
        this.multiGroupDeleteAllow = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withOnlyEmbedded(val){
        this.onlyEmbedded = val;
        return this;
    };


    /**
     * @param val {Object.<string, string>}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withPrintouts(val){
        this.printouts = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withReadPermissionLabel(val){
        this.readPermissionLabel = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withReloadColumnsWhenDynamicsAreTab(val){
        this.reloadColumnsWhenDynamicsAreTab = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withReloadTab(val){
        this.reloadTab = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withRestrictedAudit(val){
        this.restrictedAudit = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withRestrictedList(val){
        this.restrictedList = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withRestrictedRead(val){
        this.restrictedRead = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withRestrictedWrite(val){
        this.restrictedWrite = val;
        return this;
    };


    /**
     * @param val {*}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withResultComparator(val){
        this.resultComparator = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withRootClassShortId(val){
        this.rootClassShortId = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withRowFieldForDynamicColumns(val){
        this.rowFieldForDynamicColumns = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/forms/schema/definition/fields/SecuredFieldConfig.SecuredFieldConfig[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withSecuredFields(val){
        this.securedFields = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/forms/schema/definition/FormShadowFieldConfig.FormShadowFieldConfig[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withShadowFields(val){
        this.shadowFields = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withShowAdd(val){
        this.showAdd = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withShowColumns(val){
        this.showColumns = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withShowDelete(val){
        this.showDelete = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withShowExport(val){
        this.showExport = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withShowImport(val){
        this.showImport = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withShowInMenu(val){
        this.showInMenu = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withShowProductInfoBranding(val){
        this.showProductInfoBranding = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withStreamingMode(val){
        this.streamingMode = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withTargetFieldFromClassForDynamicCell(val){
        this.targetFieldFromClassForDynamicCell = val;
        return this;
    };


    /**
     * @param val {*}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withTextBelowTheListClazz(val){
        this.textBelowTheListClazz = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withTextBelowTheListExpression(val){
        this.textBelowTheListExpression = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withTextBelowTheListFunction(val){
        this.textBelowTheListFunction = val;
        return this;
    };


    /**
     * @param val {string[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withTranslatedFields(val){
        this.translatedFields = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withViewName(val){
        this.viewName = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/forms/schema/definition/ClassWatch.ClassWatch[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withWatchedClasses(val){
        this.watchedClasses = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormConfig.FormConfig}
     */
    withWritePermissionLabel(val){
        this.writePermissionLabel = val;
        return this;
    };





    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};
metadata['addFromForeignSelect'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['allowFormColumns'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['alternativeMenuLabelInConfiguration'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['appTranslations'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['auditPermissionLabel'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['basicInfoLabel'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['beforeDeleteDialogInfo'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['canChain'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['canClone'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['cellValueFieldForDynamicColumns'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['classAlias'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['classForDynamicColumnsLabel'] = {'remoteType' : '*', 'jsType' : '*', 'mapped' : 'false'};
metadata['classForValueOfDynamicCell'] = {'remoteType' : '*', 'jsType' : '*', 'mapped' : 'false'};
metadata['classIsDynamic'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['closeFormAfterInsertEntity'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['clusterByField'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['clusterByFieldLabel'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['clusterType'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['columnFieldForDynamicColumns'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['dataPermissions'] = {'remoteType' : 'module:src/server/com/silkplm/engine/forms/schema/definition/AdvancedPermissionConfig.AdvancedPermissionConfig[]', 'jsType' : 'module:src/server/com/silkplm/engine/forms/schema/definition/AdvancedPermissionConfig.AdvancedPermissionConfig[]', 'mapped' : 'false'};
metadata['defaultVisible'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['descriptionToFormUnderGrid'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['detailToClasses'] = {'remoteType' : '*', 'jsType' : '*', 'mapped' : 'false'};
metadata['details'] = {'remoteType' : 'module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig[]', 'jsType' : 'module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig[]', 'mapped' : 'false'};
metadata['detailsFilteringFields'] = {'remoteType' : 'string[]', 'jsType' : 'string[]', 'mapped' : 'false'};
metadata['devOnly'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['dynamicCells'] = {'remoteType' : '*', 'jsType' : '*', 'mapped' : 'false'};
metadata['dynamicColumns'] = {'remoteType' : '*', 'jsType' : '*', 'mapped' : 'false'};
metadata['dynamicRows'] = {'remoteType' : '*', 'jsType' : '*', 'mapped' : 'false'};
metadata['editFromForeignSelect'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['editableForm'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['editableGrid'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['effectivePermissionAudit'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['effectivePermissionList'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['effectivePermissionRead'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['effectivePermissionWrite'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['enableShowDetailsByDoubleClick'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['enabledByFeatureFlags'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]', 'jsType' : 'module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]', 'mapped' : 'false'};
metadata['enabledConfiguration'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['enabledFilters'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['enabledPrintoutsByFeatureFlags'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]', 'jsType' : 'module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]', 'mapped' : 'false'};
metadata['entityLabelExpression'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['entityLabelFunction'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['entityName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['entityPlural'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['extendedClass'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['extendedConfigs'] = {'remoteType' : 'Object.<string, module:src/server/com/silkplm/engine/forms/schema/definition/ExtendedConfig.ExtendedConfig>', 'jsType' : 'Object.<string, module:src/server/com/silkplm/engine/forms/schema/definition/ExtendedConfig.ExtendedConfig>', 'mapped' : 'false'};
metadata['extensions'] = {'remoteType' : 'module:src/server/com/silkplm/engine/forms/schema/definition/FormExtensionConfig.FormExtensionConfig[]', 'jsType' : 'module:src/server/com/silkplm/engine/forms/schema/definition/FormExtensionConfig.FormExtensionConfig[]', 'mapped' : 'false'};
metadata['extraFieldOrderForDynamicColumns'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['fieldByWhichColoringWillBeDistinguishedForDynamicColumns'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['fieldCloneOptions'] = {'remoteType' : 'Object.<string, module:src/server/com/silkplm/engine/forms/schema/definition/FieldCloneOptionsConfig.FieldCloneOptionsConfig>', 'jsType' : 'Object.<string, module:src/server/com/silkplm/engine/forms/schema/definition/FieldCloneOptionsConfig.FieldCloneOptionsConfig>', 'mapped' : 'false'};
metadata['fieldDependencies'] = {'remoteType' : 'Object.<string, string[]>', 'jsType' : 'Object.<string, string[]>', 'mapped' : 'false'};
metadata['fieldForFilterForDynamicColumns'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['fieldOrderForDynamicColumns'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['fields'] = {'remoteType' : 'module:src/server/com/silkplm/engine/forms/schema/definition/FormFieldConfig.FormFieldConfig[]', 'jsType' : 'module:src/server/com/silkplm/engine/forms/schema/definition/FormFieldConfig.FormFieldConfig[]', 'mapped' : 'false'};
metadata['fieldsMap'] = {'remoteType' : 'Object.<string, module:src/server/com/silkplm/engine/forms/schema/definition/FormFieldConfig.FormFieldConfig>', 'jsType' : 'Object.<string, module:src/server/com/silkplm/engine/forms/schema/definition/FormFieldConfig.FormFieldConfig>', 'mapped' : 'false'};
metadata['footerColCssClass'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['footerHtml'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['forceLabelTranslation'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['formClass'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['formClassLong'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['formColorHex'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['formDockFlexCss'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['formId'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['formIsView'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['formNameLabelInConfiguration'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['formTitle'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['hasConditionalAdd'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['hasCustomCanDelete'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['hasIntegrationRequiredFieldsButton'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['hasSummaryFunction'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['hasTabs'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['headerColCssClass'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['headerHtml'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['icon'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['ignoredUniqueFieldsInClone'] = {'remoteType' : 'string[]', 'jsType' : 'string[]', 'mapped' : 'false'};
metadata['interfaceTranslation'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['isDetail'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['isDynamic'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['isExtension'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['listPermissionLabel'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['masterFormConfig'] = {'remoteType' : 'module:src/server/com/silkplm/engine/forms/schema/MasterFormConfig.MasterFormConfig', 'jsType' : 'module:src/server/com/silkplm/engine/forms/schema/MasterFormConfig.MasterFormConfig', 'mapped' : 'false'};
metadata['menuGroup'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['menuGroupLabelInConfiguration'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['menuLabel'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['menuOrder'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['mixins'] = {'remoteType' : 'module:src/server/com/silkplm/engine/forms/schema/definition/MixinFormComponentConfig.MixinFormComponentConfig[]', 'jsType' : 'module:src/server/com/silkplm/engine/forms/schema/definition/MixinFormComponentConfig.MixinFormComponentConfig[]', 'mapped' : 'false'};
metadata['moduleLabelInConfiguration'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['modules'] = {'remoteType' : 'string[]', 'jsType' : 'string[]', 'mapped' : 'false'};
metadata['multiAddForeignKey'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['multiGroupDeleteAllow'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['onlyEmbedded'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['printouts'] = {'remoteType' : 'Object.<string, string>', 'jsType' : 'Object.<string, string>', 'mapped' : 'false'};
metadata['readPermissionLabel'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['reloadColumnsWhenDynamicsAreTab'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['reloadTab'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['restrictedAudit'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['restrictedList'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['restrictedRead'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['restrictedWrite'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['resultComparator'] = {'remoteType' : '*', 'jsType' : '*', 'mapped' : 'false'};
metadata['rootClassShortId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['rowFieldForDynamicColumns'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['securedFields'] = {'remoteType' : 'module:src/server/com/silkplm/engine/forms/schema/definition/fields/SecuredFieldConfig.SecuredFieldConfig[]', 'jsType' : 'module:src/server/com/silkplm/engine/forms/schema/definition/fields/SecuredFieldConfig.SecuredFieldConfig[]', 'mapped' : 'false'};
metadata['shadowFields'] = {'remoteType' : 'module:src/server/com/silkplm/engine/forms/schema/definition/FormShadowFieldConfig.FormShadowFieldConfig[]', 'jsType' : 'module:src/server/com/silkplm/engine/forms/schema/definition/FormShadowFieldConfig.FormShadowFieldConfig[]', 'mapped' : 'false'};
metadata['showAdd'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['showColumns'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['showDelete'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['showExport'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['showImport'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['showInMenu'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['showProductInfoBranding'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['streamingMode'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['targetFieldFromClassForDynamicCell'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['textBelowTheListClazz'] = {'remoteType' : '*', 'jsType' : '*', 'mapped' : 'false'};
metadata['textBelowTheListExpression'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['textBelowTheListFunction'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['translatedFields'] = {'remoteType' : 'string[]', 'jsType' : 'string[]', 'mapped' : 'false'};
metadata['viewName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['watchedClasses'] = {'remoteType' : 'module:src/server/com/silkplm/engine/forms/schema/definition/ClassWatch.ClassWatch[]', 'jsType' : 'module:src/server/com/silkplm/engine/forms/schema/definition/ClassWatch.ClassWatch[]', 'mapped' : 'false'};
metadata['writePermissionLabel'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.engine.forms.schema.definition.FormConfig';
metadata.__type_short__ = 'FormConfig';
FormConfig.prototype.__metadata__ = metadata;

FormConfig.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/engine/forms/schema/definition/FormConfig */
export default FormConfig

export { FormConfig }
